/* The PEOPLE arm's pages by first path segment: the files and folders under routes/v2, less the
   layout, index and catch-all. Only these are pulled into the arm on a PEOPLE host; every other
   address is the product's. host-rewrite.test.ts checks this list against the folder. */
export const PEOPLE_PAGES = [
  "about",
  "baa",
  "case-studies",
  "contact",
  "demo",
  "experience",
  "features",
  "inquire",
  "operating-system",
  "pitch",
  "pricing",
  "privacy",
  "security",
  "signup",
  "solutions",
  "subscribe",
  "terms",
  "why",
  "workforce",
];
